'use client';

import { useState } from 'react';

import { Loader2 } from 'lucide-react';
import { signIn } from 'next-auth/react';

import { Button } from '../ui/button';

export function LoginButton() {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Button
      onClick={async () => {
        setIsLoading(true);
        try {
          await signIn();
        } finally {
          setIsLoading(false);
        }
      }}
      variant="secondary"
      size="sm"
      disabled={isLoading}
    >
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      Login
    </Button>
  );
}
